"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  showFetchRevisionsFailedError: false,
  showGoogleAccountSwitcher: false,
  showGoogleAuthError: false,
  showGoogleAuthModal: false,
  showGoogleDocImportError: false,
  showGoogleDocImportImageUploadError: false,
  showGoogleDocsPicker: false,
  showRevertFailedError: false,
  showRevisions: false,
  showShareModal: false
};

var UISettings = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(UISettings, _Record);

  function UISettings() {
    (0, _classCallCheck2.default)(this, UISettings);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UISettings).apply(this, arguments));
  }

  return UISettings;
}((0, _immutable.Record)(DEFAULTS));

exports.default = UISettings;
module.exports = exports.default;